// Footer get year
const currentYear = new Date().getFullYear();
    document.getElementById('currentYear').textContent = `${currentYear}`;